<ng-template #modalMissionDetail let-close="close">
	<div class="modal-header">
		<h5 class="modal-title">
			Détails
			{{ isMissionAReunion() ? missionObject : labelIntervention }}
			du
			{{
				changeStringDateIntoDate(
					modalDataMission?.mission.missionRequest.date
				).toLocaleDateString('fr-Fr')
			}}
			(semaine
			{{
				dateUtils.getWeekNumber(
					changeStringDateIntoDate(
						modalDataMission?.mission.missionRequest.date
					)
				)
			}})
			<i
				role="button"
				class="bi icon bi-info-square fw-bold ms-3 fs-3"
				*ngIf="
					this.modalDataMission?.mission.id &&
					!isMissionAReunion() &&
					!isIntervenant &&
					selectedServiceCenterId === this.user.employee.serviceCenter.id
				"
				aria-hidden="true"
				(click)="goPrestationPage()"
			></i>
			<i
				role="button"
				class="bi icon bi-info-square fw-bold ms-3 fs-3"
				*ngIf="
					isMissionAReunion() &&
					selectedServiceCenterId === this.user.employee.serviceCenter.id
				"
				aria-hidden="true"
				(click)="goMeetingPage()"
			></i>
		</h5>
		<button
			type="button"
			class="btn-close close pull-right"
			aria-label="Close"
			(click)="bsModalMissionDetail.hide()"
		></button>
	</div>
	<div class="modal-body">
		<div class="container-fluid">
			<div
				*ngIf="isStateOfMissionCanceled || this.missionHasBeenManuallyCanceled"
				class="row"
			>
				<div class="col-md d-flex justify-content-center">
					<div class="alert alert-danger fw-bold" role="alert">
						Cet événement a été annulé. Cause :
						{{
							StateMissionEnum[modalDataMission.mission.state] ===
							StateMissionEnum.CANCELED_FOR_BENEFICIAIRE
								? 'absence du bénéficiaire.'
								: "absence de l'intervenant."
						}}
					</div>
				</div>
			</div>
			<form
				[formGroup]="modalForm"
				[ngClass]="
					isStateOfMissionCanceled || this.missionHasBeenManuallyCanceled
						? 'unselectable'
						: ''
				"
			>
                <!-- Dossier DH -->
                <div
                        class="row p-2"
                        *ngIf="this.modalDataMission?.mission?.missionRequest?.beneficiaire"
                >
                    <div class="col-md-4 d-flex justify-content-end">
                        <span class="font-weight-bold mt-2">Dossier DH :</span>
                    </div>
                    <div class="col-md-8">
						<span
                                readonly
                                class="position-relative form-control width-380px shadow d-flex align-items-center"
                        >
							<span class="pe-5 form-control-plaintext">{{
                                    missionRequest?.parcoursId
                                }}</span>

						</span>
                    </div>
                </div>

				<!-- Motif mission -->
				<div
					class="row p-2"
					*ngIf="this.modalDataMission?.mission?.missionRequest?.beneficiaire"
				>
					<div class="col-md-4 d-flex justify-content-end">
						<span class="font-weight-bold mt-2">Bénéficiaire :</span>
					</div>
					<div class="col-md-8">
						<span
							readonly
							class="position-relative form-control width-380px shadow d-flex align-items-center"
						>
							<span class="pe-5">{{ missionObject }}</span>
							<i
								role="button"
								class="bi bi-person-video2 position-absolute icon ms-3 fs-4"
								*ngIf="
									this.modalDataMission?.mission?.missionRequest
										?.beneficiaire &&
									!isIntervenant &&
									selectedServiceCenterId ===
										this.user.employee.serviceCenter.id
								"
								(click)="goBeneficiairePage()"
								aria-hidden="true"
							></i>
						</span>
					</div>
				</div>

				<!-- Compétence mission -->
				<div
					class="row p-2"
					*ngIf="
						this.modalDataMission?.mission?.missionRequest?.careSkills &&
						!isMissionAReunion()
					"
				>
					<div class="col-md-4 d-flex justify-content-end">
						<span class="font-weight-bold mt-2">
							Compétence {{ labelIntervention }} :
						</span>
					</div>
					<div class="col-md-8">
						<span
							readonly
							class="position-relative form-control width-380px shadow d-flex align-items-center"
						>
							<span class="pe-5">
								<span
									*ngFor="
										let skill of this.modalDataMission?.mission?.missionRequest
											?.careSkills;
										let last = last
									"
								>
									{{ skill.name ? skill.name.replaceAll('_', ' ') : 'Sans'
									}}<span *ngIf="!last"> | </span>
								</span>
							</span>
						</span>
					</div>
				</div>

				<!-- Intervenant -->
				<div class="row p-2 mt-3 mb-1" *ngIf="isGroupMission">
					<div class="col-md-4 d-flex justify-content-center">
						<span class="fw-bold"></span>
					</div>
					<div class="col-md-8 d-flex justify-content-center">
						<span class="fw-bold">
							{{ labelInterventionCapitalized }} groupée (
							{{ modalDataMission.mission.missionRequest.nombreIntervenant }}
							{{ labelIntervenantPluralized }})
						</span>
					</div>
				</div>
				<div class="row p-2" *ngIf="!isMissionAReunion()">
					<div class="col-md-4 d-flex justify-content-end">
						<span class="font-weight-bold mt-2">
							{{
								isGroupMission
									? labelIntervenantCapitalized + 's'
									: labelIntervenantCapitalized
							}}
							:
						</span>
					</div>
					<div class="col-md-8">
						<span
							*ngIf="
								modalDataMission?.action !== 'Edited' ||
								hasMissionAlreadyHappened
							"
							readonly
							class="position-relative pe-5 form-control width-380px shadow d-flex align-items-center"
						>
							{{
								shouldShowEmployee()
									? getEmployeeDisplayName(modalDataMission.employee)
									: isGroupMission || modalDataMission?.mission?.missionParent
									? attendeesAsString
									: 'Aucun'
							}}
							<i
								role="button"
								class="bi bi-person-video2 position-absolute icon ms-3 fs-4"
								*ngIf="
									modalDataMission?.employee &&
									modalDataMission?.employee.active &&
									!isIntervenant &&
									selectedServiceCenterId === user.employee.serviceCenter.id
								"
								(click)="goIntervenantPage()"
								aria-hidden="true"
							></i>
						</span>
						<span
							*ngIf="
								modalDataMission?.action === 'Edited' &&
								!hasMissionAlreadyHappened
							"
						>
							<select
								class="form-select form-select-lg"
								name="employeeMission"
								[(ngModel)]="modalDataMission.employee"
								[compareWith]="compareEmployee"
								[ngModelOptions]="{ standalone: true }"
							>
								<option [ngValue]="null">Aucun</option>
								<option
									*ngFor="
										let employee of filterEmployeesListForProjectManager()
									"
									[ngValue]="employee"
								>
									{{ getEmployeeDisplayName(employee) }}
								</option>
							</select>
							<div
								*ngIf="
									modalDataMission?.employee &&
									!isCareSkillMissionMatchingWithCareSkillEmp()
								"
								class=""
							>
								<div class="col-md d-flex justify-content-center mt-2">
									<div class="alert alert-warning fw-bold" role="alert">
										La compétence
										{{ labelIntervenantCapitalized | lowercase }} n'est pas
										compatible avec la compétence {{ labelIntervention }}.
									</div>
								</div>
							</div>
							<div
								*ngIf="
									modalDataMission?.employee &&
									!isIntervenantCompatibleForBeneficiaire()
								"
								class=""
							>
								<div class="justify-content-center mt-2">
									<div class="alert alert-warning fw-bold" role="alert">
										Incompatible avec le {{ labelBeneficiaire }}.
									</div>
								</div>
							</div>
							<div
								*ngIf="
									modalDataMission?.employee && !isMissionAreaMatchingForEmp()
								"
								class=""
							>
								<div class="justify-content-center mt-2">
									<div class="alert alert-warning fw-bold" role="alert">
										Les secteurs de l'{{
											labelIntervenantCapitalized | lowercase
										}}
										sont incompatibles avec celui du {{ labelBeneficiaire }}.
									</div>
								</div>
							</div>
						</span>
					</div>
				</div>

				<!-- Type de prestation -->
				<div
					class="row p-2"
					*ngIf="(this.isSESSAD || this.isSAE) && !isMissionAReunion()"
				>
					<div class="col-md-4 d-flex justify-content-end">
						<span class="font-weight-bold mt-2">Type :</span>
					</div>
					<div class="col-md-8">
						<span>
							<input
								readonly
								class="form-control width-380px shadow"
								value="{{
									modalDataMission?.mission.missionRequest.missionType.type
								}}"
						/></span>
					</div>
				</div>

				<!-- Prescripteur -->
				<div
					class="row p-2"
					*ngIf="
						this.isSAE &&
						modalDataMission.mission.missionRequest.missionType.type ===
							MISSION_TYPE_PRESCRIPTION
					"
				>
					<div class="col-md-4 d-flex justify-content-end">
						<span class="font-weight-bold mt-2">Prescripteur :</span>
					</div>
					<div class="col-md-8">
						<span>
							<input
								readonly
								class="form-control width-380px shadow"
								value="{{
									modalDataMission?.prescriberRequest?.prescriber?.name
								}}"
						/></span>
					</div>
				</div>
				<!-- Tel Prescripteur -->
				<div
					class="row p-2"
					*ngIf="
						this.isSAE &&
						modalDataMission.mission.missionRequest.missionType.type ===
							MISSION_TYPE_PRESCRIPTION
					"
				>
					<div class="col-md-4 d-flex justify-content-end">
						<span class="font-weight-bold mt-2">Tel. Prescripteur :</span>
					</div>
					<div class="col-md-8">
						<span>
							<input
								readonly
								class="form-control width-380px shadow"
								value="{{
									modalDataMission?.prescriberRequest?.prescriber?.phone
								}}"
						/></span>
					</div>
				</div>
				<!-- Mail Prescripteur -->
				<div
					class="row p-2"
					*ngIf="
						this.isSAE &&
						modalDataMission.mission.missionRequest.missionType.type ===
							MISSION_TYPE_PRESCRIPTION
					"
				>
					<div class="col-md-4 d-flex justify-content-end">
						<span class="font-weight-bold mt-2">Mail Prescripteur :</span>
					</div>
					<div class="col-md-8">
						<span>
							<input
								readonly
								class="form-control width-380px shadow"
								value="{{
									modalDataMission?.prescriberRequest?.prescriber?.email
								}}"
						/></span>
					</div>
				</div>
				<!-- Visio Prescripteur -->
				<div class="row p-2" *ngIf="shouldDisplayRemoteLink()">
					<div class="col-md-4 d-flex justify-content-end">
						<span class="font-weight-bold mt-2">Lien visio :</span>
					</div>
					<div class="col-md-8 mt-2">
						<span>
							<a href="{{ getMeetingLink() }}" target="_blank">Cliquez ici</a>
						</span>
					</div>
				</div>

				<!-- Lieu de prestation -->
				<div
					class="row p-2"
					*ngIf="
						(this.isSESSAD || this.isSAE) &&
						!isMissionAReunion() &&
						modalDataMission?.mission.missionRequest.beneficiaire &&
						!modalDataMission?.mission.missionRequest.remote
					"
				>
					<div class="col-md-4 d-flex justify-content-end">
						<span class="font-weight-bold mt-2">Lieu :</span>
					</div>
					<div class="col-md-8">
						<span>
							<input
								readonly
								class="form-control width-380px shadow"
								value="{{ getEventLocation() }}"
						/></span>
					</div>
				</div>

				<!-- Adresse -->
				<div
					class="row p-2"
					*ngIf="
						!isMissionAReunion() &&
						modalDataMission?.mission.missionRequest.beneficiaire &&
						!modalDataMission?.mission.missionRequest.remote
					"
				>
					<div class="col-md-4 d-flex justify-content-end">
						<span class="font-weight-bold mt-2">Adresse :</span>
					</div>
					<div class="col-md-8">
						<span>
							<input
								readonly
								class="form-control width-380px shadow"
								value="{{
									modalDataMission?.mission.missionRequest.missionPlace
										? modalDataMission?.mission.missionRequest.missionPlace
												?.address?.label
										: modalDataMission?.mission.missionRequest?.beneficiaire
												?.address?.label
								}}"
						/></span>
					</div>
				</div>

				<!-- Véhicule -->
				<div
					class="row p-2"
					*ngIf="
						isVehiculeActive &&
						modalDataMission?.mission.missionRequest.beneficiaire
					"
				>
					<div
						class="col-md-4 d-flex justify-content-end"
						*ngIf="modalDataMission?.mission.route"
					>
						<span class="font-weight-bold mt-2">Véhicule :</span>
					</div>
					<div class="col-md-8" *ngIf="modalDataMission?.mission.route">
						<span
							*ngIf="modalDataMission?.action !== 'Edited'"
							readonly
							class="position-relative form-control width-380px shadow d-flex align-items-center"
							>{{
								getVehicleOfMission(modalDataMission?.mission.id)
									? getVehicleOfMission(modalDataMission?.mission.id).name +
									  ' - ' +
									  getVehicleOfMission(modalDataMission?.mission.id).model
									: 'Aucun'
							}}

							<i
								role="button"
								class="bi bi-cursor position-absolute icon ms-3 fs-4"
								*ngIf="getVehicleOfMission(modalDataMission?.mission.id)"
								(click)="
									goVehiclePage(
										getVehicleOfMission(modalDataMission?.mission.id).id
									)
								"
								aria-hidden="true"
							></i>
						</span>
						<span *ngIf="modalDataMission?.action === 'Edited'">
							<select
								class="form-select form-select-lg"
								name="vehicleRoute"
								[(ngModel)]="modalDataMission.mission.route.vehicle"
								[compareWith]="compareVehicule"
								[ngModelOptions]="{ standalone: true }"
							>
								<option [ngValue]="null">Aucun</option>
								<option
									*ngFor="let vehicle of vehiculeList"
									[ngValue]="vehicle"
								>
									{{ vehicle.name + ' - ' + vehicle.model }}
								</option>
							</select>
						</span>
					</div>
				</div>

				<!-- Fenêtre de temps (hasMissionTW) -->
				<div
					class="row p-2"
					*ngIf="hasMissionTW() && !modalDataMission.employee"
				>
					<div class="col-md-4 d-flex justify-content-end">
						<span class="font-weight-bold mt-2"> Fenêtre de temps : </span>
					</div>
					<div class="col-md-3">
						<span>
							<div class="input-group mb-3 shadow">
								<input
									readonly
									type="text"
									class="form-control"
									value="{{
										dateUtils.timeConvert(
											modalDataMission?.mission.missionRequest.readyTime
										)
									}}"
								/>
								<span class="input-group-text" id="basic-addon2"
									><i class="bi bi-clock" aria-hidden="true"></i
								></span>
							</div>
						</span>
					</div>
					<div class="col-md-2 d-flex justify-content-center mt-2">à</div>
					<div class="col-md-3">
						<span>
							<div class="input-group mb-3 shadow">
								<input
									readonly
									type="text"
									class="form-control"
									value="{{
										dateUtils.timeConvert(
											modalDataMission?.mission.missionRequest.dueTime
										)
									}}"
								/>
								<span class="input-group-text" id="basic-addon2"
									><i class="bi bi-clock" aria-hidden="true"></i
								></span>
							</div>
						</span>
					</div>
				</div>

				<!-- Horaires mission (réalisées/planifiées) -->
				<div
					class="row p-2"
					*ngIf="isSESSAD || isSAE || modalDataMission.employee"
				>
					<div class="col-md-4 d-flex justify-content-end">
						<span class="font-weight-bold mt-2">
							Horaires
							{{ hasMissionAlreadyHappened ? 'réalisés ' : 'planifiés ' }}:
						</span>
					</div>
					<!-- READ ONLY -->
					<div
						class="col-md-3"
						*ngIf="modalDataMission?.action !== 'Edited' || isMissionAReunion()"
					>
						<span>
							<div class="input-group mb-3 shadow">
								<input
									readonly
									type="text"
									class="form-control"
									value="{{ dateUtils.timeConvert(getStartMission()) }}"
								/>
								<span class="input-group-text" id="basic-addon2"
									><i class="bi bi-clock" aria-hidden="true"></i
								></span>
							</div>
						</span>
					</div>
					<!-- EDITION -->
					<div
						class="col-md-3"
						*ngIf="
							!isMissionAReunion() && modalDataMission?.action === 'Edited'
						"
					>
						<span>
							<div class="input-group mb-3">
								<timepicker
									class="ms-4"
									id="inputDurationFormation"
									[(ngModel)]="updatedStartMissionDate"
									[showMeridian]="false"
									[ngModelOptions]="{ standalone: true }"
								></timepicker>
							</div>
						</span>
					</div>
					<div class="col-md-2 d-flex justify-content-center mt-2">à</div>
					<!-- READ ONLY -->
					<div
						class="col-md-3 ml-auto"
						*ngIf="modalDataMission?.action !== 'Edited' || isMissionAReunion()"
					>
						<span>
							<div class="input-group mb-3 shadow">
								<input
									readonly
									type="text"
									class="form-control"
									value="{{ dateUtils.timeConvert(getEndMission()) }}"
								/>
								<span class="input-group-text" id="basic-addon2"
									><i class="bi bi-clock" aria-hidden="true"></i
								></span>
							</div>
						</span>
					</div>
					<!-- EDITION -->
					<div
						class="col-md-3"
						*ngIf="
							!isMissionAReunion() && modalDataMission?.action === 'Edited'
						"
					>
						<span>
							<div class="input-group mb-3">
								<timepicker
									class="ms-4"
									id="inputDurationFormation"
									[(ngModel)]="updatedEndMissionDate"
									[showMeridian]="false"
									[ngModelOptions]="{ standalone: true }"
								></timepicker>
							</div>
						</span>
					</div>
				</div>

				<!-- Durée mission et TRAJET -->
				<div class="row p-2" *ngIf="!isMissionAReunion()">
					<div class="col-md-4 d-flex justify-content-end mt-2">
						<span class="font-weight-bold">Durée :</span>
					</div>
					<div class="col-md-3">
						<span>
							<div class="input-group mb-3 shadow">
								<input
									readonly
									type="text"
									class="form-control"
									value="{{
										dateUtils.timeConvert(
											modalDataMission.mission.missionRequest.duration
										)
									}}"
								/>
								<span class="input-group-text" id="basic-addon2"
									><i class="bi bi-clock" aria-hidden="true"></i
								></span>
							</div>
						</span>
					</div>
					<div
						class="col-md-2 d-flex justify-content-end mt-2"
						*ngIf="modalDataMission?.mission?.missionRequest?.beneficiaire"
					>
						<span class="font-weight-bold">Trajet :</span>
					</div>
					<div
						class="col-md-3"
						*ngIf="modalDataMission?.mission?.missionRequest?.beneficiaire"
					>
						<span>
							<div class="input-group mb-3 shadow">
								<input
									readonly
									type="text"
									class="form-control"
									value="{{
										dateUtils.timeConvert(
											getEndTravelMission() - getStartTravelMission()
										)
									}}"
								/>
								<span class="input-group-text" id="basic-addon2"
									><i class="bi bi-clock" aria-hidden="true"></i
								></span>
							</div>
						</span>
					</div>
				</div>

				<div *ngIf="isMissionAReunion()" class="row p-2">
					<div class="col-md-4 d-flex justify-content-end">
						<span class="font-weight-bold">Participants :</span>
					</div>
					<div class="col-md-8">
						<span *ngFor="let member of reunionMembersString">
							{{ member }} <br />
						</span>
					</div>
				</div>

				<div *ngIf="modalDataMission.mission?.missionRequest" class="row p-2">
					<form
						[ngClass]="!isMobile && 'd-flex justify-content-end'"
						id="formationDetailForm"
						[formGroup]="notesForm"
					>
						<div [ngClass]="isMobile ? 'col-12' : 'col-10'">
							<label
								for="inputNotes"
								[ngClass]="
									isMobile ? 'row d-flex justify-content-end' : 'col-2'
								"
								class="form-label theme-main-color font-weight-bold pe-2"
								>Notes :
							</label>
							<!--  -->
							<textarea
								class="form-control"
								[ngClass]="isMobile ? 'row' : 'col-10'"
								formControlName="notes"
								[rows]="isMobile ? 8 : 6"
								[readonly]="modalDataMission?.action !== 'Edited'"
								>{{ modalDataMission.mission?.missionRequest.notes }}</textarea
							>
						</div>
					</form>
				</div>
				<div
					class="row p-2"
					*ngIf="modalDataMission.mission?.planner && modalDataMission.employee"
				>
					<div class="col-md d-flex justify-content-end">
						<span class="text-muted"
							>Planifié par
							{{
								modalDataMission.mission?.planner.firstName +
									' ' +
									modalDataMission.mission?.planner.lastName
							}}</span
						>
					</div>
				</div>
			</form>
		</div>
	</div>
	<div class="modal-footer d-flex flex-row justify-content-between">
		<div>
			<button
				type="button"
				class="btn theme-red-button me-2"
				aria-hidden="true"
				*ngIf="
					isPlanif &&
					isEventEditable &&
					isCancelable() &&
					!isMissionAReunion() &&
					!isStateOfMissionCanceled
				"
				[disabled]="
					isStateOfMissionCanceled ||
					this.missionHasBeenManuallyCanceled ||
					isCancelButtonClicked
				"
				(click)="openConfirmationCancelModal()"
			>
				Annuler la mission
			</button>

			<button
				type="button"
				class="btn theme-red-button me-2"
				aria-hidden="true"
				*ngIf="
					isPlanif &&
					isEventEditable &&
					isStateOfMissionCanceled &&
					!isMissionAReunion()
				"
				[disabled]="!isStateOfMissionCanceled"
				(click)="undoCancelMission()"
			>
				Réactiver {{ labelIntervention }}
			</button>
		</div>

		<div>
			<button
				type="button"
				class="btn theme-main-color-button me-2"
				(click)="bsModalMissionDetail.hide()"
			>
				Retour
			</button>

			<button
				*ngIf="
					!isMobile &&
					modalDataMission?.action !== 'Edited' &&
					isEventEditable &&
					!(
						solution.validate ||
						user.role.id === Authority.INTERVENANT ||
						user.role.id === Authority.CHARGE_MISSION
					)
				"
				type="button"
				class="btn theme-main-color-full-button"
				[disabled]="
					!isEditable(modalDataMission?.mission) ||
					isStateOfMissionCanceled ||
					this.missionHasBeenManuallyCanceled
				"
				(click)="editModal()"
			>
				<i
					class="bi bi-lock"
					aria-hidden="true"
					*ngIf="
						!isEditable(modalDataMission?.mission) ||
						isStateOfMissionCanceled ||
						this.missionHasBeenManuallyCanceled
					"
				></i>
				Éditer
			</button>
			<button
				*ngIf="!isMobile && modalDataMission?.action === 'Edited'"
				type="button"
				class="btn theme-green-button"
				(click)="validateModal()"
				[disabled]="isValidateBtnDisabled"
			>
				Valider
			</button>
		</div>
	</div>
</ng-template>

<ng-template #modalRouteDetail let-close="close">
	<div class="modal-header">
		<h5 class="modal-title">
			Détails tournée du
			{{
				changeStringDateIntoDate(modalDataRoute?.route.date).toLocaleDateString(
					'fr-Fr'
				)
			}}
			(semaine
			{{ dateUtils.getWeekNumber(modalDataRoute.route.date) }} )
		</h5>
		<button
			type="button"
			class="btn-close close pull-right"
			aria-label="Close"
			(click)="bsModalRouteDetail.hide()"
		>
			<!-- <span aria-hidden="true">&times;</span> -->
		</button>
	</div>
	<div class="modal-body">
		<div class="container-fluid">
			<!-- Intervenant -->
			<div class="row p-2">
				<div class="col-md-4 d-flex justify-content-end">
					<span class="font-weight-bold mt-2"
						>{{ labelIntervenantCapitalized }} :</span
					>
				</div>
				<div class="col-md-8">
					<span
						readonly
						class="position-relative form-control width-380px shadow d-flex align-items-center"
					>
						{{
							modalDataRoute?.employee
								? getEmployeeDisplayName(modalDataRoute.employee)
								: 'Aucun'
						}}
						<i
							role="button"
							class="bi bi-person-video2 position-absolute icon ms-3 fs-4"
							*ngIf="
								modalDataRoute?.employee && modalDataRoute?.employee.active
							"
							(click)="goIntervenantPage(modalDataRoute?.employee.id)"
							aria-hidden="true"
						></i>
					</span>
				</div>
			</div>

			<!-- Véhicule -->
			<div class="row p-2" *ngIf="isVehiculeActive">
				<div class="col-md-4 d-flex justify-content-end">
					<span class="font-weight-bold mt-2">Véhicule :</span>
				</div>
				<div class="col-md-8">
					<span
						*ngIf="modalDataRoute?.action !== 'Edited'"
						readonly
						class="position-relative form-control width-380px shadow d-flex align-items-center"
						>{{
							modalDataRoute?.route.vehicle
								? modalDataRoute?.route.vehicle.name +
								  ' - ' +
								  modalDataRoute?.route.vehicle.model
								: 'Aucun'
						}}

						<i
							role="button"
							class="bi bi-cursor position-absolute icon ms-3 fs-4"
							*ngIf="this.modalDataRoute?.route.vehicle"
							(click)="goVehiclePage(modalDataRoute?.route.vehicle.id)"
							aria-hidden="true"
						></i>
					</span>

					<span *ngIf="modalDataRoute?.action === 'Edited'">
						<select
							class="form-select form-select-lg"
							name="vehicleRoute"
							[(ngModel)]="modalDataRoute.route.vehicle"
							[compareWith]="compareVehicule"
							[ngModelOptions]="{ standalone: true }"
						>
							<option [ngValue]="null">Aucun</option>
							<option *ngFor="let vehicle of vehiculeList" [ngValue]="vehicle">
								{{ vehicle.name + ' - ' + vehicle.model }}
							</option>
						</select>
					</span>
				</div>
			</div>

			<br />

			<!-- Liste missions tournée -->
			<div class="accordion" id="accordionExample">
				<div class="accordion-item">
					<div class="py-3">
						<span class="ms-3 accordion-header theme-main-color">
							<span class="fw-bold">Départ : </span>
							{{ dateUtils.timeConvert(modalDataRoute.route.depotStartTime) }}
						</span>
					</div>
				</div>
				<span
					*ngFor="let mission of modalDataRoute.route.missions; let i = index"
				>
					<div
						class="accordion-item"
						*ngIf="isMissionAReunion(mission) && mission.missionParent"
					>
						<div class="py-3">
							<span class="ms-3 accordion-header theme-main-color">
								<span class="fw-bold">{{ MISSION_TYPE_REUNION_TYPE }} : </span>
								{{
									dateUtils.timeConvert(
										modalDataRoute.route.missions[i].realStart
									) +
										' - ' +
										dateUtils.timeConvert(
											modalDataRoute.route.missions[i].realEnd
										)
								}}
							</span>
						</div>
					</div>
					<div
						class="accordion-item"
						*ngIf="
							mission.realTravelEnd - mission.realTravelStart > 0 &&
							!isMissionAReunion(mission)
						"
					>
						<div class="py-3">
							<span class="ms-3 accordion-header theme-main-color">
								<span class="fw-bold">Temps de trajet : </span>
								{{
									mission.realTravelEnd - mission.realTravelStart
										| number : '1.0-0'
								}}
								minutes
							</span>
						</div>
					</div>
					<div class="accordion-item" *ngIf="!isMissionAReunion(mission)">
						<h2 class="accordion-header" id="{{ 'heading-' + i }}">
							<button
								class="accordion-button collapsed"
								type="button"
								data-bs-toggle="collapse"
								[attr.data-bs-target]="'#collapse-' + i"
								aria-expanded="false"
								aria-controls="'collapse-' + i"
							>
								<span class="theme-main-color"
									><span class="fw-bold"
										>{{ labelInterventionCapitalized + ' ' + (i + 1) }} : </span
									><span>{{
										mission.missionRequest.beneficiaire.firstName +
											' ' +
											mission.missionRequest.beneficiaire.lastName +
											' (' +
											dateUtils.timeConvert(
												modalDataRoute.route.missions[i].realStart
											) +
											' - ' +
											dateUtils.timeConvert(
												modalDataRoute.route.missions[i].realEnd
											) +
											' )'
									}}</span></span
								>
							</button>
						</h2>
						<div
							id="{{ 'collapse-' + i }}"
							class="accordion-collapse collapse"
							aria-labelledby="'heading-' + i"
							data-bs-parent="#accordionExample"
						>
							<div class="accordion-body">
								<div
									*ngIf="isMissionCanceled(modalDataRoute?.route.missions[i])"
									class="row"
								>
									<div class="col-md d-flex justify-content-center">
										<div class="alert alert-danger fw-bold" role="alert">
											Cet événement a été annulé. Cause :
											{{
												StateMissionEnum[
													modalDataRoute.route.missions[i].state
												] === StateMissionEnum.CANCELED_FOR_BENEFICIAIRE
													? 'absence du bénéficiaire.'
													: "absence de l'intervenant."
											}}
										</div>
									</div>
								</div>

								<div class="row p-2">
									<div class="col-md-4 d-flex justify-content-end">
										<span class="font-weight-bold mt-2">Bénéficiaire :</span>
									</div>
									<div class="col-md-8">
										<span
											readonly
											class="position-relative form-control width-380px shadow d-flex align-items-center"
											>{{
												modalDataRoute?.route.missions[i]?.missionRequest
													?.beneficiaire?.firstName +
													' ' +
													modalDataRoute?.route.missions[i]?.missionRequest
														?.beneficiaire?.lastName
											}}
											<i
												role="button"
												class="bi bi-person-video2 position-absolute icon ms-3 fs-4"
												*ngIf="
													this.modalDataRoute?.route.missions[i]?.missionRequest
														?.beneficiaire
												"
												(click)="
													goBeneficiairePage(
														modalDataRoute?.route.missions[i]?.missionRequest
															?.beneficiaire.id
													)
												"
												aria-hidden="true"
											></i>
										</span>
									</div>
								</div>
								<div
									class="row p-2"
									*ngIf="
										isMissionPlacesActive &&
										!isMissionAReunion(modalDataRoute?.route.missions[i]) &&
										modalDataRoute?.route.missions[i].missionRequest
											.beneficiaire
									"
								>
									<div class="col-md-4 d-flex justify-content-end">
										<span class="font-weight-bold mt-2">Lieu :</span>
									</div>
									<div class="col-md-8">
										<span>
											<input
												readonly
												class="form-control width-380px shadow"
												value="{{
													getEventLocation(modalDataRoute?.route.missions[i])
												}}"
										/></span>
									</div>
								</div>
								<div
									class="row p-2"
									*ngIf="
										isMissionPlacesActive &&
										!isMissionAReunion(modalDataRoute?.route.missions[i]) &&
										modalDataRoute?.route.missions[i].missionRequest
											.beneficiaire
									"
								>
									<div class="col-md-4 d-flex justify-content-end">
										<span class="font-weight-bold mt-2">Adresse :</span>
									</div>
									<div class="col-md-8">
										<span>
											<input
												readonly
												class="form-control width-380px shadow"
												value="{{
													modalDataRoute?.route.missions[i].missionRequest
														.missionPlace
														? modalDataRoute?.route.missions[i].missionRequest
																.missionPlace?.address?.label
														: modalDataRoute?.route.missions[i].missionRequest
																?.beneficiaire?.address?.label
												}}"
										/></span>
									</div>
								</div>

								<div
									class="row p-2"
									*ngIf="
										!isMissionAReunion(modalDataRoute?.route.missions[i]) &&
										modalDataRoute?.action !== 'Edited'
									"
								>
									<div class="col-md-4 d-flex justify-content-end">
										<span class="font-weight-bold mt-2"
											>Horaires
											{{
												hasEventAlreadyHappened(
													modalDataRoute?.route.missions[i]
												)
													? 'réalisés'
													: 'planifiés'
											}}
											:</span
										>
									</div>
									<div class="col-md-3">
										<span>
											<div class="input-group mb-3 shadow">
												<input
													readonly
													type="text"
													class="form-control"
													value="{{
														dateUtils.timeConvert(
															modalDataRoute?.route.missions[i].realStart
														)
													}}"
												/>
												<span class="input-group-text" id="basic-addon2"
													><i class="bi bi-clock" aria-hidden="true"></i
												></span>
											</div>
										</span>
									</div>
									<div class="col-md-2 d-flex justify-content-center mt-2">
										à
									</div>
									<div class="col-md-3">
										<span>
											<div class="input-group mb-3 shadow">
												<input
													readonly
													type="text"
													class="form-control"
													value="{{
														dateUtils.timeConvert(
															modalDataRoute?.route.missions[i].realEnd
														)
													}}"
												/>
												<span class="input-group-text" id="basic-addon2"
													><i class="bi bi-clock" aria-hidden="true"></i
												></span>
											</div>
										</span>
									</div>
								</div>

								<div
									*ngIf="isMissionAReunion(modalDataRoute?.route.missions[i])"
									class="row p-2"
								>
									<div class="col-md-4 d-flex justify-content-end">
										<span class="font-weight-bold">Participants :</span>
									</div>
									<div class="col-md-8">
										<span *ngFor="let member of reunionMembersString">
											{{ member }} <br />
										</span>
									</div>
								</div>
								<div
									*ngIf="
										modalDataRoute?.route.missions[i]?.missionRequest &&
										modalDataRoute?.route.missions[i]?.missionRequest.notes
									"
									class="row p-2"
								>
									<div class="col-md-4 d-flex justify-content-end">
										<span class="font-weight-bold">Notes :</span>
									</div>
									<div class="col-md-8">
										<span>
											{{
												modalDataRoute?.route.missions[i]?.missionRequest.notes
											}}</span
										>
									</div>
								</div>
								<div
									class="row p-2"
									*ngIf="
										modalDataRoute?.route.missions[i]?.planner &&
										modalDataRoute?.employee
									"
								>
									<div class="col-md d-flex justify-content-end">
										<span class="text-muted"
											>Planifié par
											{{
												modalDataRoute?.route.missions[i]?.planner.firstName +
													' ' +
													modalDataRoute?.route.missions[i]?.planner.lastName
											}}</span
										>
									</div>
								</div>
							</div>
						</div>
					</div>
				</span>
				<div
					class="accordion-item"
					*ngIf="
						modalDataRoute.route.depotEndTime -
							modalDataRoute.route.missions[
								modalDataRoute.route.missions.length - 1
							].realEnd >
						0
					"
				>
					<div class="py-3">
						<span class="ms-3 accordion-header theme-main-color">
							<span class="fw-bold">Temps de trajet : </span>
							{{
								modalDataRoute.route.depotEndTime -
									modalDataRoute.route.missions[
										modalDataRoute.route.missions.length - 1
									].realEnd | number : '1.0-0'
							}}
							minutes
						</span>
					</div>
				</div>
				<div class="accordion-item">
					<div class="py-3">
						<span class="ms-3 accordion-header theme-main-color">
							<span class="fw-bold">Retour : </span>
							{{ dateUtils.timeConvert(modalDataRoute.route.depotEndTime) }}
						</span>
					</div>
				</div>
			</div>
		</div>
		<br />
		<div class="modal-footer">
			<button
				type="button"
				class="btn theme-main-color-button me-2"
				(click)="bsModalRouteDetail.hide()"
			>
				Retour
			</button>
			<button
				type="button"
				class="btn theme-main-color-full-button"
				*ngIf="
					!isMobile && user.role.id === Authority.PLANIFICATEUR && !isSESSAD
				"
				[disabled]="!isPlanif || isSESSAD"
				(click)="goToRoute(modalDataRoute?.route)"
			>
				<i class="bi bi-lock" aria-hidden="true" *ngIf="!isPlanif"></i>
				Éditer la tournée
			</button>
			<button
				type="button"
				class="btn theme-main-color-full-button"
				*ngIf="
					!isMobile &&
					user.role.id === Authority.PLANIFICATEUR &&
					isVehiculeActive &&
					modalDataRoute?.action !== 'Edited'
				"
				[disabled]="!isPlanif || !isVehiculeActive"
				(click)="editModalRoute()"
			>
				<i class="bi bi-lock" aria-hidden="true" *ngIf="!isPlanif"></i>
				{{
					modalDataRoute?.route.vehicle
						? 'Éditer le véhicule'
						: 'Ajouter un véhicule'
				}}
			</button>
			<button
				*ngIf="!isMobile && modalDataRoute?.action === 'Edited'"
				type="button"
				class="btn theme-green-button"
				(click)="validateVehicleChange()"
				[disabled]="isValidateBtnDisabled"
			>
				Valider
			</button>
		</div>
	</div>
</ng-template>

<ng-template #modalContentVacation let-close="close">
	<div class="modal-header">
		<h5 class="modal-title theme-main-color">
			Détails sur l'absence du
			{{
				changeStringDateIntoDate(vacation?.startDate).toLocaleDateString(
					'fr-Fr'
				)
			}}
			<span *ngIf="vacation?.startDate.getDay() !== vacation?.endDate.getDay()">
				au
				{{
					changeStringDateIntoDate(vacation?.endDate).toLocaleDateString(
						'fr-FR'
					)
				}}
			</span>
		</h5>
		<button
			type="button"
			class="btn-close close pull-right"
			aria-label="Close"
			(click)="bsModalContentVacation.hide()"
		>
			<!-- <span aria-hidden="true">&times;</span> -->
		</button>
	</div>
	<div class="modal-body">
		<div class="container-fluid">
			<div class="row">
				<div class="col-md-4 d-flex justify-content-end">
					<span class="font-weight-bold mt-2 theme-main-color">Motif : </span>
				</div>
				<div class="col-md-8">
					<input
						*ngIf="modalDataVacation.action !== 'Edited'"
						readonly
						type="text"
						class="form-control theme-main-color"
						value="{{ vacation?.vacationType.type }}"
					/>
					<span *ngIf="modalDataVacation?.action === 'Edited'">
						<div class="btn-group" dropdown>
							<button
								id="button-basic"
								dropdownToggle
								type="button"
								class="btn theme-main-color-button width-380px btn-block dropdown-toggle shadow"
								aria-controls="dropdown-basic"
							>
								{{ modalDataVacation.vacation.vacationType.type }}
								<span class="caret float-end"></span>
							</button>
							<ul
								id="dropdown-basic"
								*dropdownMenu
								class="dropdown-menu ul-custom-size"
								role="menu"
								aria-labelledby="button-basic"
							>
								<li
									role="menuitem theme-main-color"
									*ngFor="let vacationType of vacationTypes"
									(click)="selectAbsenceType(vacationType)"
								>
									<a class="dropdown-item">{{ vacationType.type }} </a>
								</li>
							</ul>
						</div>
					</span>
				</div>
			</div>

			<div class="row">
				<div class="col-md-4 d-flex justify-content-end"></div>
				<div
					class="col-md-8"
					*ngIf="this.vacation?.vacationType?.workingTimeAccountedFor"
				>
					<div class="alert alert-info text-center p-2 mt-2" role="alert">
						Le temps de travail sera comptabilisé pour cette absence.
					</div>
				</div>
			</div>

			<div class="row p-2">
				<div class="col-md-4 d-flex justify-content-end">
					<span class="font-weight-bold mt-2 theme-main-color"
						>{{ labelIntervenantCapitalized }} :</span
					>
				</div>
				<div class="col-md-8">
					<input
						readonly
						*ngIf="modalDataVacation?.action !== 'Edited'"
						type="text"
						class="form-control theme-main-color"
						value="{{
							modalDataVacation.employee?.firstName +
								' ' +
								modalDataVacation.employee?.lastName
						}}"
					/>
					<div
						class="btn-group"
						dropdown
						*ngIf="modalDataVacation?.action === 'Edited'"
					>
						<button
							id="button-basic"
							dropdownToggle
							type="button"
							class="btn theme-main-color-button width-380px btn-block dropdown-toggle shadow"
							aria-controls="dropdown-basic"
							[class.disabled]="!isPlanif"
						>
							{{ modalDataVacation.employee?.firstName }}
							{{ modalDataVacation.employee?.lastName }}
							<span class="caret float-end"></span>
						</button>
						<ul
							id="dropdown-basic"
							*dropdownMenu
							class="dropdown-menu ul-custom-size"
							role="menu"
							aria-labelledby="button-basic"
						>
							<li
								role="menuitem"
								*ngFor="let employee of employeesList"
								(click)="selectItfcAbs(employee)"
							>
								<a class="dropdown-item theme-main-color"
									>{{ employee.firstName + ' ' + employee.lastName }}
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>

			<div class="row p-2" *ngIf="modalDataVacation?.action !== 'Edited'">
				<div class="col-md-4 d-flex justify-content-end">
					<span class="font-weight-bold mt-2 theme-main-color">Début :</span>
				</div>
				<div class="col-md-3">
					<div class="input-group mb-3 shadow">
						<input
							readonly
							type="text"
							class="form-control theme-main-color"
							value="{{
								dateUtils.getFullDateFromDateAndMinutes(
									changeStringDateIntoDate(vacation.startDate),
									vacation.startTime
								) | date : 'd/M/y'
							}}"
						/>
						<span class="input-group-text" id="basic-addon2"
							><i
								class="bi bi-calendar-event-fill theme-main-color"
								aria-hidden="true"
							></i
						></span>
					</div>
				</div>
				<div
					class="col-md-2 mt-2 d-flex justify-content-center theme-main-color"
				>
					à
				</div>
				<div class="col-md-3">
					<div class="input-group mb-3 shadow">
						<input
							readonly
							type="text"
							class="form-control theme-main-color"
							value="{{
								dateUtils.getFullDateFromDateAndMinutes(
									changeStringDateIntoDate(vacation.startDate),
									vacation.startTime
								) | date : 'H:mm'
							}}"
						/>
						<span class="input-group-text" id="basic-addon2"
							><i class="bi bi-clock theme-main-color" aria-hidden="true"></i
						></span>
					</div>
				</div>
			</div>

			<div class="row p-2" *ngIf="modalDataVacation?.action !== 'Edited'">
				<div class="col-md-4 d-flex justify-content-end">
					<span class="font-weight-bold mt-2 theme-main-color">Fin :</span>
				</div>
				<div class="col-md-3">
					<div class="input-group mb-3 shadow">
						<input
							readonly
							type="text"
							class="form-control theme-main-color"
							value="{{
								dateUtils.getFullDateFromDateAndMinutes(
									vacation.endDate,
									vacation.endTime
								) | date : 'd/M/y'
							}}"
						/>
						<span class="input-group-text" id="basic-addon2"
							><i
								class="bi bi-calendar-event-fill theme-main-color"
								aria-hidden="true"
							></i
						></span>
					</div>
				</div>
				<div
					class="col-md-2 mt-2 d-flex justify-content-center theme-main-color"
				>
					à
				</div>
				<div class="col-md-3">
					<div class="input-group mb-3 shadow">
						<input
							readonly
							type="text"
							class="form-control theme-main-color"
							value="{{
								dateUtils.getFullDateFromDateAndMinutes(
									vacation.endDate,
									vacation.endTime
								) | date : 'H:mm'
							}}"
						/>
						<span class="input-group-text" id="basic-addon2"
							><i class="bi bi-clock theme-main-color" aria-hidden="true"></i
						></span>
					</div>
				</div>
			</div>

			<div class="row p-2" *ngIf="modalDataVacation?.action === 'Edited'">
				<div class="col-md-4 d-flex justify-content-end">
					<span class="font-weight-bold mt-2 theme-main-color"
						>Sélection des dates :</span
					>
				</div>
				<div class="col-md-4 row">
					<div class="input-group mb-3">
						<input
							class="form-control theme-main-color width-380px shadow"
							#dp="bsDatepicker"
							bsDatepicker
							[(ngModel)]="vacationRangeDate"
							(onHidden)="selectVacationDate()"
						/>
						<button
							class="input-group-text theme-main-color"
							(click)="dp.toggle()"
							[attr.aria-expanded]="dp.isOpen"
							type="button"
						>
							<i
								class="bi bi-calendar-event-fill theme-main-color"
								aria-hidden="true"
							></i>
						</button>
					</div>
				</div>
			</div>

			<div
				class="row p-2"
				*ngIf="!isMobile && modalDataVacation?.action === 'Edited'"
			>
				<div
					class="col-lg-4 d-flex justify-content-end mt-4 font-weight-bold theme-main-color"
				>
					*Début :
				</div>
				<div class="col-lg-8">
					<timepicker
						[(ngModel)]="modalDataVacation.datetimeStart"
						[showMeridian]="false"
						[minuteStep]="15"
					>
					</timepicker>
				</div>
			</div>
			<div
				class="row p-2"
				*ngIf="!isMobile && modalDataVacation?.action === 'Edited'"
			>
				<div
					class="col-lg-4 d-flex justify-content-end mt-4 font-weight-bold theme-main-color"
				>
					*Fin :
				</div>
				<div class="col-lg-8">
					<timepicker
						[(ngModel)]="modalDataVacation.datetimeEnd"
						[showMeridian]="false"
						[minuteStep]="15"
					>
					</timepicker>
				</div>
			</div>

			<div
				class="row p-2"
				*ngIf="vacation.notes || modalDataVacation?.action === 'Edited'"
			>
				<div class="col-md-4 d-flex justify-content-end mt-3 font-weight-bold">
					*Notes :
				</div>
				<div class="col-md-8">
					<textarea
						class="form-control"
						id="inputNotes"
						[(ngModel)]="vacation.notes"
						[readonly]="isMobile || modalDataVacation?.action !== 'Edited'"
					></textarea>
				</div>
			</div>
		</div>
	</div>

	<div class="modal-footer">
		<button
			type="button"
			class="btn theme-main-color-button me-2"
			(click)="resetAction(); bsModalContentVacation.hide()"
		>
			Retour
		</button>
		<button
			type="button"
			class="btn theme-red-button"
			*ngIf="
				!isMobile && modalDataVacation?.action !== 'Edited' && isDeletable()
			"
			(click)="openConfirmationDeleteVacationModal()"
		>
			<i class="bi bi-trash-fill" aria-hidden="true"></i>
			Supprimer
		</button>
		<button
			type="button"
			class="btn theme-main-color-full-button"
			*ngIf="
				!isMobile &&
				modalDataVacation?.action !== 'Edited' &&
				user.role.id === Authority.PLANIFICATEUR
			"
			(click)="editModalVacation(vacation)"
			[disabled]="!isPlanif && user.employee.id !== vacation.employeeId"
		>
			<i
				class="bi bi-lock"
				aria-hidden="true"
				*ngIf="!isPlanif && user.employee.id !== vacation.employeeId"
			></i>
			Éditer
		</button>
		<button
			*ngIf="!isMobile && modalDataVacation?.action === 'Edited'"
			type="button"
			class="btn theme-green-button"
			(click)="validateVacationChange()"
			[disabled]="isAddingOrEditingVacationInProgress"
		>
			Valider
		</button>
	</div>
</ng-template>

<ng-template #confirmDeleteModal let-close="close">
	<div class="modal-header">
		<div class="modal-title">Confirmation suppression</div>
		<button
			type="button"
			class="btn-close close pull-right"
			aria-label="Close"
			(click)="bsModalConfirmDelete.hide()"
		>
			<!-- <span aria-hidden="true">&times;</span> -->
		</button>
	</div>
	<div class="modal-body">
		Êtes vous sûr de vouloir supprimer cet événement ?
	</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn theme-main-color-button me-2"
			(click)="bsModalConfirmDelete.hide()"
		>
			Retour
		</button>
		<button
			*ngIf="!isMobile"
			type="button"
			class="btn theme-green-button"
			(click)="confirmDelete(); bsModalConfirmDelete.hide()"
		>
			Valider
		</button>
	</div>
</ng-template>

<ng-template #confirmEditModal let-close="close">
	<div class="modal-header">
		<div class="modal-title">Confirmation édition horaires</div>
		<button
			type="button"
			class="btn-close close pull-right"
			aria-label="Close"
			(click)="bsModalConfirmEdit.hide()"
		>
			<!-- <span aria-hidden="true">&times;</span> -->
		</button>
	</div>
	<div class="modal-body">
		La durée de la {{ labelIntervention }} sera modifiée. Voulez-vous continuer
		?
	</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn theme-main-color-button me-2"
			(click)="bsModalConfirmEdit.hide()"
		>
			Retour
		</button>
		<button
			*ngIf="!isMobile"
			type="button"
			class="btn theme-green-button"
			(click)="confirmEdit(); bsModalConfirmEdit.hide()"
		>
			Valider
		</button>
	</div>
</ng-template>

<ng-template #confirmCancelModal let-close="close">
	<div class="modal-header">
		<div class="modal-title">Confirmation annulation</div>
		<button
			type="button"
			class="btn-close close pull-right"
			aria-label="Close"
			(click)="bsModalConfirmCancel.hide()"
		>
			<!-- <span aria-hidden="true">&times;</span> -->
		</button>
	</div>
	<div class="modal-body">Pourquoi annulez-vous cet événement ?</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn theme-main-color-button me-2"
			(click)="bsModalConfirmCancel.hide()"
		>
			Retour
		</button>
		<button
			*ngIf="!isMobile"
			type="button"
			class="btn theme-green-button"
			(click)="confirmCancelation('beneficiaire')"
			[disabled]="isCancelButtonClicked"
		>
			Le bénéficiaire est absent
		</button>
		<button
			*ngIf="!isMobile"
			type="button"
			class="btn theme-green-button"
			(click)="confirmCancelation('intervenant')"
			[disabled]="isCancelButtonClicked"
		>
			L'intervenant est absent
		</button>
	</div>
</ng-template>
